<template>
  <div class="message-scrolling" v-if="messages && messages.length > 0">
    <div v-for="(ms, index) in messages" :key="index" :class="{'animate-up': animateUp}">
      <span class="iconfont iconlingdang icon"></span>
      <span class="not-wrap desc">{{ms.msgContent}}</span>
      <a href="javascript:void(0)" class="a" @click="toDetail(ms)">查看详情</a>
    </div>
  </div>
</template>
<script>
  import eventBus from '../../libs/eventBus'

  const stateTime = 30 // 停留时间

  export default {
    name: 'messageScrolling',
    components: {},
    data () {
      return {
        messages: [],
        scrolling: '',
        animateUp: false
      }
    },
    mounted () {},
    methods: {
      init () {
        this.messages = [].concat(this.messagesFromStore)
        this.startScrolling()
      },
      startScrolling () {
        if (!this.messages || this.messages.length < 0) {
          this.endScrolling()
          return
        }
        this.scrolling && this.endScrolling()
        this.inScrolling()
        this.scrolling = setInterval(this.inScrolling, stateTime * 1000)
      },
      inScrolling () {
        // 动效
        this.animateUp = true
        let _this = this
        setTimeout(() => {
          _this.messages.push(_this.messages[0])
          _this.messages.shift()
          _this.animateUp = false
        }, 500)
      },
      endScrolling () {
        if (this.scrolling) {
          clearInterval(this.scrolling)
          this.scrolling = null
        }
      },
      toDetail (message) {
        const isSame = this.$route.name === 'messagesAll'
        const type = ['unRead', 'read'][message.readState] || 'unRead'
        this.$router.push({name: 'messagesAll', query: { type, pushMsgId: message.pushMsgId }})
        isSame && eventBus.$emit('messages-all-init')
      }
    },
    computed: {
      messagesFromStore () {
        return this.$store.state.app.messagesScrolling
      }
    },
    watch: {
      messagesFromStore: {
        deep: true,
        handler: 'init'
      }
    }
  }
</script>

<style lang="less" scoped>
  .font-base() {
    font-size: 16px;
    font-weight: 500;
  }

  .message-scrolling {
    width: calc(100% - 1000px);
    height: 38px;
    overflow-y: hidden;
    position: fixed;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 21;
    text-align: left;
    .icon {
      color: #009AFF;
      font-size: 24px;
      vertical-align: middle;
    }
    .desc {
      .font-base;
      display: inline-block;
      max-width: calc(100% - 100px);
      vertical-align: middle;
    }
    .a {
      .font-base;
      vertical-align: middle;
      text-decoration-line: underline;
    }
  }

  /* 滚动动画 */
  .animate-up {
    transition: all 0.5s ease-in-out;
    transform: translateY(-36px);
  }
</style>



// WEBPACK FOOTER //
// src/views/components/message-scrolling.vue